const compareItems = (itemA, itemB) => {
    if (itemA.name.toUpperCase() > itemB.name.toUpperCase()) return 1;
    if (itemB.name.toUpperCase() > itemA.name.toUpperCase()) return -1;
    return 0;
};

export default compareItems;
